import React from 'react';
import { Modal } from 'antd';
import Confetti from 'react-confetti';
import { Button } from 'components/AntD';

import useWindowSize from 'hooks/useWindowResize';
import ThankYouGraphic from 'components/SurveyExperience/NewComponents/ReviewPage/ThankYouGraphic';

interface SuccessModalProps {
  successText: string;
  nextSteps: React.ReactNode[];
  isVisible: boolean;
  onClose(): void;
}

const REFERENCE_CHECK_HOMEPAGE_URL = 'https://www.searchlight.ai/reference-checks';

const SuccessWithUpsellModal = ({
  successText,
  nextSteps,
  isVisible,
  onClose,
}: SuccessModalProps) => {
  const { width, height } = useWindowSize();

  return (
    <>
      <Modal
        maskClosable={false}
        className="tw-p-6 tw-w-max"
        closable={false}
        visible={isVisible}
        footer={null}
      >
        <div className="tw-flex tw-flex-col tw-items-center">
          <ThankYouGraphic />
          <h1 className="tw-text-[20px] tw-leading-7 tw-text-gray-900 tw-font-semibold tw-text-center tw-mt-4 tw-mb-5">
            {successText}
          </h1>
          <div className="tw-text-base tw-text-gray-700 tw-font-normal tw-mb-5 tw-text-center">
            Want to bring Searchlight References to your org?
          </div>
          <div className="tw-rounded tw-border tw-border-gray-300 tw-bg-gray-100 tw-p-4 tw-flex tw-flex-col tw-items-center md:tw-mx-10">
            <div className="tw-text-base tw-font-medium tw-text-gray-900">
              Here&apos;s what to expect next:
            </div>
            <div className="md:tw-px-10">
              {nextSteps?.map((step, idx) => (
                <li key={idx} className="tw-flex tw-flex-col tw-mt-6">
                  <div className="tw-flex tw-flex-row tw-items-center tw-gap-3 tw-mb-4">
                    <div className="tw-bg-gray-900 tw-text-white tw-text-sm tw-font-semibold tw-leading-5 tw-aspect-square tw-w-[28px] tw-h-[28px] tw-rounded-full tw-flex tw-items-center tw-justify-center">
                      {idx}
                    </div>
                    <h5 className="tw-text-sm tw-text-gray-900 tw-font-normal tw-max-w-[300px]">
                      {step}
                    </h5>
                  </div>
                </li>
              ))}
            </div>
          </div>
          <div className="tw-flex tw-flex-row tw-gap-4">
            <Button
              htmlType="button"
              className="tw-my-5"
              color="default"
              variant="contained"
              onClick={() => {
                onClose();
              }}
            >
              Back
            </Button>
            <Button
              htmlType="button"
              className="tw-my-5"
              color="primary"
              variant="contained"
              href={REFERENCE_CHECK_HOMEPAGE_URL}
              target="_blank"
              rel="noreferrer"
            >
              Learn more
            </Button>
          </div>
        </div>
      </Modal>
      {isVisible && (
        <Confetti
          width={width}
          height={height}
          numberOfPieces={1000}
          tweenDuration={60000}
          recycle={false}
        />
      )}
    </>
  );
};

export default SuccessWithUpsellModal;
